export enum EmailSendLogAnchorType {
  expiryDate = 'EXPIRY_DATE',
  termStartDate = 'TERM_START_DATE',
}

export enum EmailSendLogStatus {
  pending = 'PENDING',
  sent = 'SENT',
  failed = 'FAILED',
  skipped = 'SKIPPED',
}

export interface EmailSendLog {
  readonly id: string;

  tenantId: string;
  warrantyId: string;
  templateId: string;

  anchorType: EmailSendLogAnchorType;
  anchorDate: Date;
  offsetDays: number;
  scheduledFor: Date;

  status: EmailSendLogStatus;
  recipientEmail: string | null;
  messageId: string | null;
  errorMessage: string | null;

  attemptCount: number;
  firstAttemptedAt: Date | null;
  lastAttemptedAt: Date | null;
  sentAt: Date | null;

  jobRunId: string | null;

  readonly createdAt: Date;
  readonly updatedAt: Date;
}
